import i18n from "i18next";

/**
 * Resolve an ISO-3166-1 alpha-2 code to a display name in the active language.
 * Falls back to the upper-cased code when the code is unknown or unsupported.
 */
export const getCountryName = (
  countryCode: string | null | undefined
): string | undefined => {
  const code = countryCode?.trim().toUpperCase();

  if (code == null || code === "") {
    return undefined;
  }

  try {
    // fallback: "none" makes `of` return undefined for unassigned codes so the
    // code below is the single fallback path.
    return (
      new Intl.DisplayNames([i18n.language], {
        type: "region",
        fallback: "none",
      }).of(code) ?? code
    );
  } catch {
    return code;
  }
};
